import ReportPoSales from '@/models/ReportPoSales/ReportPoSales';

export default class ReportPoSalesFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterCustomer = '';
		this.filterDestination = '';
		this.filterPartNo = '';
		this.filterPoNumber = '';
		this.filterDiDeliveryDateFrom = '';
		this.filterDiDeliveryDateTo = '';
		this.filterStatusDelivery = '';
		this.tempId = '';
		this.customerName = '';
		this.destinationName = '';
		this.partNumber = '';
		this.partName = '';
		this.poNoCustomer = '';
		this.qtyDelivery = '';
		this.qtyActualSupply = '';
		this.balance = '';
		this.amount = '';
		this.statusDelivery = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterCustomer : '0',
			filterDestination : '0',
			filterPartNo : '0',
			filterPoNumber : '0',
			filterDiDeliveryDateFrom : '0',
			filterDiDeliveryDateTo : '0',
			filterStatusDelivery : '0',
			tempId : '0',
			customerName : '0',
			destinationName : '0',
			partNumber : '0',
			partName : '0',
			poNoCustomer : '0',
			qtyDelivery : '0',
			qtyActualSupply : '0',
			balance : '0',
			amount : '0',
			statusDelivery : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}